(() => {
  'use strict';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  try { paused ||= localStorage.getItem('ororo-motion') === 'off'; } catch {}
  const heatState = new WeakMap();
  const variantState = new WeakMap();
  const setText = (parent, selector, text) => { const node = parent.querySelector(selector); if (node) node.textContent = text; };
  function motion() {
    root.dataset.motion = paused ? 'off' : 'on';
    const button = document.querySelector('.motion-toggle');
    button?.setAttribute('aria-pressed', String(paused));
    button?.setAttribute('aria-label', paused ? 'Resume animations' : 'Pause animations');
    if (button) setText(button, '.motion-label', paused ? 'Motion paused' : 'Pause motion');
  }
  function renderHeat(section) {
    const state = heatState.get(section);
    if (!state) return;
    const model = section.querySelector('.hero-product, .thermal-product');
    model.dataset.side = state.side;
    model.dataset.heat = state.on ? 'on' : 'off';
    model.dataset.level = state.level;
    model.dataset.zone = state.zone || 'all';
    model.querySelector('.front-photo').setAttribute('aria-hidden', String(state.side !== 'front'));
    model.querySelector('.back-photo').setAttribute('aria-hidden', String(state.side !== 'back'));
    section.querySelectorAll('[data-heat-side]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.heatSide === state.side)));
    section.querySelectorAll('.heat-settings button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.level === state.level)));
    section.querySelectorAll('button[data-zone]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.zone === state.zone)));
    section.querySelector('.heat-toggle')?.setAttribute('aria-pressed', String(state.on));
    setText(section, '[data-heat-label]', state.on ? 'Heat on' : 'Heat off');
    setText(section, '[data-heat-zones]', state.side === 'front' ? 'SEE-THROUGH VIEW · REAR NECK + BACK HEATING' : 'NECK + BACK');
    const previewNote = section.querySelector('[data-heat-preview]');
    if (previewNote) {
      previewNote.dataset.defaultLabel ||= previewNote.textContent;
      previewNote.textContent = state.side === 'front' && state.on ? 'SEE-THROUGH VIEW · REAR HEATING' : previewNote.dataset.defaultLabel;
    }
    const callout = section.querySelector('.product-callout');
    if (callout) callout.hidden = state.side !== 'back';
    const index = {low:1,medium:2,high:3}[state.level];
    const current = section.querySelector(`.heat-settings button[data-level="${state.level}"]`);
    if (current) {
      setText(section, '.heat-description h3', current.dataset.levelTitle);
      setText(section, '.heat-description p', current.dataset.levelCopy);
    }
    setText(section, '.level-index', String(index).padStart(2,'0'));
    setText(section, '.live-label', `${state.level.toUpperCase()} HEAT`);
    setText(section, '[data-meter-level]', state.on ? String(index).padStart(2,'0') : '00');
    const meter = section.querySelector('.meter-fill');
    if (meter) meter.style.strokeDashoffset = 283 * (1 - (state.on ? index / 3 : 0));
    section.style.setProperty('--ambient-strength', state.on ? [.35,.72,1][index-1] : .05);
  }
  function initVariants(scope) {
    scope.querySelectorAll('.ororo-product-form').forEach(form => {
      if (variantState.has(form)) return;
      const select = form.querySelector('[data-ororo-variant]');
      const picker = form.querySelector('.ororo-option-picker');
      if (!select || !picker) return;
      let variants;
      try { variants = JSON.parse(form.querySelector('[data-ororo-variants]').textContent); } catch { return; }
      const groups = [...picker.querySelectorAll('[data-option-index]')];
      const sizes = ['S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
      groups.filter(group => group.dataset.optionName === 'Size').forEach(group => {
        const values = group.querySelector('.ororo-option-values');
        [...values.children].sort((a,b) => sizes.indexOf(a.querySelector('input').value) - sizes.indexOf(b.querySelector('input').value)).forEach(label => values.append(label));
      });
      variantState.set(form, {variants, groups});
      const initial = variants.find(v => String(v.id) === select.value) || variants[0];
      if (!initial) return;
      groups.forEach(group => group.querySelectorAll('input').forEach(input => {
        input.checked = input.value === initial.options[Number(group.dataset.optionIndex)];
      }));
      form.dataset.enhanced = 'true';
      picker.hidden = false;
      syncVariant(form);
    });
  }
  function syncVariant(form) {
    const state = variantState.get(form);
    if (!state) return;
    const {variants, groups} = state;
    const choices = [];
    let color = 'Black';
    groups.forEach(group => {
      const value = group.querySelector('input:checked')?.value;
      choices[Number(group.dataset.optionIndex)] = value;
      setText(group, '[data-option-value]', value || 'Choose an option');
      if (group.dataset.optionName === 'Color') color = value;
    });
    const variant = variants.find(v => v.options.every((value, index) => value === choices[index]));
    const select = form.querySelector('[data-ororo-variant]');
    select.value = variant ? String(variant.id) : '';
    const info = form.closest('.product-info');
    if (variant) setText(info, '[data-variant-price]', variant.price);
    const submit = form.querySelector('[name=add]');
    submit.disabled = !variant?.available;
    setText(submit, '[data-add-text]', variant ? (variant.available ? submit.dataset.addLabel : submit.dataset.soldOutLabel) : 'Unavailable combination');
    groups.forEach(group => group.querySelectorAll('input').forEach(input => {
      const candidate = [...choices];
      candidate[Number(group.dataset.optionIndex)] = input.value;
      const match = variants.find(v => v.options.every((value,index) => value === candidate[index]));
      input.disabled = !match;
      input.closest('label').classList.toggle('is-unavailable', !match?.available);
    }));
    const section = form.closest('.product-section');
    section.dataset.selectedColor = color || 'Black';
    section.dispatchEvent(new CustomEvent('ororo:variant-change', {detail:{color,variant}}));
    if (variant && location.pathname.includes('/products/')) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
  function init(scope) {
    scope.querySelectorAll('.hero, .technology').forEach(section => {
      if (!section.querySelector('.hero-product, .thermal-product') || heatState.has(section)) return;
      heatState.set(section, {side:'back',level:'medium',on:true,zone:null});
      renderHeat(section);
    });
    initVariants(scope);
    motion();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.matches('.motion-toggle')) {
      paused = !paused;
      try { localStorage.setItem('ororo-motion', paused ? 'off' : 'on'); } catch {}
      motion();
    }
    if (button.matches('.menu-button')) {
      const nav = document.querySelector('#mobile-nav');
      if (nav) {
        nav.hidden = !nav.hidden;
        button.setAttribute('aria-expanded', String(!nav.hidden));
        button.setAttribute('aria-label', nav.hidden ? 'Open menu' : 'Close menu');
        nav.style.top = `${document.querySelector('.header').getBoundingClientRect().bottom}px`;
      }
    }
    if (button.hasAttribute('data-close-dialog')) button.closest('dialog')?.close();
    const section = button.closest('.hero, .technology');
    const state = section && heatState.get(section);
    if (!state) return;
    if (button.hasAttribute('data-heat-side')) { state.side = button.dataset.heatSide; state.zone = null; }
    else if (button.closest('.heat-settings')) { state.level = button.dataset.level; state.on = true; }
    else if (button.hasAttribute('data-zone')) { state.zone = state.zone === button.dataset.zone ? null : button.dataset.zone; state.side = button.dataset.zone === 'pockets' ? 'front' : 'back'; state.on = true; }
    else if (button.matches('.heat-toggle')) state.on = !state.on;
    else return;
    renderHeat(section);
  });
  function closeMenu() {
    const nav = document.querySelector('#mobile-nav');
    if (nav) nav.hidden = true;
    const button = document.querySelector('.menu-button');
    button?.setAttribute('aria-expanded','false');
    button?.setAttribute('aria-label','Open menu');
  }
  document.addEventListener('click', event => { if (event.target.closest('#mobile-nav a')) closeMenu(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
  document.addEventListener('change', event => {
    if (event.target.matches('.ororo-option-picker input')) {
      syncVariant(event.target.closest('form'));
      return;
    }
    if (!event.target.matches('[data-ororo-variant]')) return;
    const select = event.target, selected = select.selectedOptions[0];
    const section = select.closest('.product-info');
    setText(section, '[data-variant-price]', selected.dataset.price);
    const submit = section.querySelector('[name=add]');
    submit.disabled = selected.dataset.available !== 'true';
    setText(submit, '[data-add-text]', submit.disabled ? submit.dataset.soldOutLabel : submit.dataset.addLabel);
  });
  const dialog = document.querySelector('#image-dialog');
  dialog?.addEventListener('close', () => document.body.classList.remove('modal-open'));
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', () => closeMenu());
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('details');
    if (item) item.open = true;
  });
  reduced.addEventListener('change', event => { paused = event.matches; motion(); });
  let scrollFrame = 0;
  function paint() {
    scrollFrame = 0;
    const max = root.scrollHeight - innerHeight;
    root.style.setProperty('--read-progress', max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0);
  }
  addEventListener('scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(paint); }, {passive:true});
  init(document);
  paint();
})();
